export default {
	"exchange.CannotExceed20Characters": "不能超過20個字元",
	"exchange.PleaseEnterTheRedemptionCode": "請輸入兌換碼",
	"exchange.TheRedemptionCodeIsNotLegitimate": "兌換碼不合法",
	"exchange.PleaseEnterTheActivationCodeToRedeemTheProduct": "請輸入啟動碼兌換商品",
	"exchange.RedeemNow": "立即兌換",
	"exchange.TheRedemptionCodeIsAContentRedemptionVoucherObtainedFromAThirdParty": "兌換碼是從第三方獲取的內容兌換憑證，",
	"exchange.CanBeRedeemedForTheCorrespondingGoods": "可兌換相應的商品",
	"exchange.IfYouHaveAnyQuestionsPleaseContactCustomerService": "如有疑問，請聯繫客服 >"
}